export default "/images/6d2c2ad0e014d892b4b78a8af7b646f9.avif";